module.exports = __webpack_public_path__ + "img/Topas Multi Finance.bac053f3.png";